<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:modelColumnDefs="modelColumnDefs"
			:navigableDetail="false"
		></pui-datatable>
	</div>
</template>

<script>

export default {
	name: 'vmagentebytype-grid',
	components: {
	},
	data() {
		return {
			modelName: 'vmagentebytype',
			modelColumnDefs: {
			}
		}
	}
}
</script>
